import {Inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ImageGalleryCarouselComponent} from '../view/image-gallery-carousel/image-gallery-carousel.component';
import {ProjectFile} from '../data/project/project-file';
import {API_URL} from '../../../../../../core/src/lib/core/utils/tokens';
import {FileService} from '../../../../../../core/src/lib/misc/data/file/file.service';
import {PdfPreviewDialogComponent} from '../view/pdf-preview-dialog/pdf-preview-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class FileOpenerService {

  constructor(
    @Inject(API_URL) protected apiUrl: string,
    protected dialog: MatDialog,
    protected fileService: FileService
  ) {
  }

  openFile(projectFile: ProjectFile, files: ProjectFile[], showSourceButton: boolean) {
    if (projectFile.ext === 'pdf') {
      this.openPdfLabels(projectFile, showSourceButton);
    } else if (projectFile.ext === 'jpg' || projectFile.ext === 'jpeg' || projectFile.ext === 'png' || projectFile.ext === 'webp') {
      const imgFileLinks = [];

      files.forEach(file => {
        if (file.ext === 'jpg' || file.ext === 'jpeg' || file.ext === 'png' || file.ext === 'webp') {
          imgFileLinks.push(this.fileService.getDownLoadFileLink(file.id))
        }
      });

      this.openGallery(projectFile, imgFileLinks, showSourceButton);
    } else {
      this.downloadFile(projectFile.id)
    }
  }

  openGallery(projectFile, imgFileLinks: string[], showSourceButton: boolean) {
    const dialogRef = this.dialog.open(ImageGalleryCarouselComponent, {
      data: {
        dialogHeader: projectFile.name,
        clickedImageId: projectFile.id,
        images: imgFileLinks,
        showSourceButton
      },
      panelClass: 'image-carousel-dialog'
    });

    return dialogRef
  }

  downloadFile(projectFileId: number) {
    window.open(this.apiUrl + this.fileService.getDownLoadFileLink(projectFileId), '_blank');
  }

  openPdfLabels(projectFile: ProjectFile, showSourceButton: boolean) {
    const dialogRef = this.dialog.open(PdfPreviewDialogComponent, {
      data: {
        dialogHeader: projectFile.name,
        link: this.fileService.getDownLoadFileLink(projectFile.id),
        showSendButton: showSourceButton
      },
      panelClass: 'pdf-preview-dialog'
    });

    return dialogRef
  }
}
